/** Indique si la chaîne ressemble à du HTML (sinon texte brut legacy). */
export function isRichTextHtml(value) {
  return /<[a-z][\s\S]*>/i.test(String(value || ''));
}

/** Texte brut → paragraphe Tiptap ; HTML inchangé. */
export function toEditorHtml(value) {
  if (!value) return '<p></p>';
  if (isRichTextHtml(value)) return value;
  const escaped = String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return `<p>${escaped}</p>`;
}

/**
 * Paragraphes vides de fin retirés d'un HTML sérialisé.
 *
 * Tiptap ajoute automatiquement un `<p>` vide quand le document ne finit pas
 * par un paragraphe (`trailingNode` de StarterKit) : il sert à pouvoir taper
 * sous une liste ou un titre, mais il partait tel quel dans le HTML enregistré
 * et laissait une ligne vide sous le texte, dans l'éditeur comme sur le site.
 * On le retire à la sérialisation, pas à l'édition : la place pour écrire
 * reste, ce qui est stocké est propre.
 */
const TRAILING_EMPTY_PARAGRAPHS = /(?:<p(?:\s[^>]*)?>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>\s*)+$/i;

export function stripTrailingEmptyParagraphs(html) {
  if (!html) return html;
  return String(html).replace(TRAILING_EMPTY_PARAGRAPHS, '');
}

/**
 * Texte nu d'un fragment HTML. Le passage par le parseur n'est pas un luxe :
 * une apostrophe typographique est écrite `&rsquo;` par l'éditeur riche, et un
 * simple retrait des balises la laisserait telle quelle dans le libellé.
 */
export function plainText(html) {
  const raw = String(html || '');
  if (!raw) return '';
  const text = typeof DOMParser === 'undefined'
    ? raw.replace(/<[^>]+>/g, ' ')
    : new DOMParser().parseFromString(raw, 'text/html').body.textContent || '';
  return text.replace(/\s+/g, ' ').trim();
}
